module.exports = __webpack_public_path__ + "img/illegal_cut_grey_al.66b20974.svg";